import { createSlice } from "@reduxjs/toolkit";

const permissionSlice = createSlice({
  name: "localpermissions",
  initialState: {
    permissions: localStorage.getItem("permissions")
      ? JSON.parse(localStorage.getItem("permissions"))
      : [],
  },
  reducers: {
    permissionsUpdated: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const { permissionsUpdated } = permissionSlice.actions;

// THUNK
export const updateLocalStoragePermissions = (newPermissions) => (dispatch) => {
  try {
    localStorage.setItem("permissions", JSON.stringify(newPermissions));

    dispatch(permissionsUpdated(newPermissions));
  } catch (error) {
    console.log(error);
  }
};

export default permissionSlice.reducer;
